const ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID;
const ADS_LABEL = process.env.REACT_APP_GOOGLE_ADS_LEAD_LABEL;
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
const PIXEL_IDS = (PIXEL_ID || "").split(",").map((id) => id.trim()).filter(Boolean);
const fbTrack = (ev) => PIXEL_IDS.forEach((id) => window.fbq("trackSingle", id, ev));
const KEY = "md_cookie_consent";
const MAX_AGE = 1000 * 60 * 60 * 24 * 182;
const ATTR_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid", "fbclid"];

export const trackersConfigured = () => Boolean(ADS_ID || PIXEL_ID);

export function getConsent() {
  try {
    const c = JSON.parse(localStorage.getItem(KEY));
    return c && Date.now() - c.at < MAX_AGE ? c : null;
  } catch {
    return null;
  }
}

export function saveConsent(ads) {
  localStorage.setItem(KEY, JSON.stringify({ ads, at: Date.now() }));
  if (ads) {
    if (loaded && window.fbq) window.fbq("consent", "grant");
    loadTrackers();
    return;
  }
  if (window.gtag) window.gtag("consent", "update", { ad_storage: "denied", ad_user_data: "denied", ad_personalization: "denied" });
  if (window.fbq) window.fbq("consent", "revoke");
  if (loaded) window.location.reload();
}

const addScript = (src) => {
  const s = document.createElement("script");
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
};

let loaded = false;
export function loadTrackers() {
  if (loaded || !getConsent()?.ads) return;
  loaded = true;
  if (ADS_ID) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); }; // eslint-disable-line prefer-rest-params
    window.gtag("consent", "default", { ad_storage: "granted", ad_user_data: "granted", ad_personalization: "granted", analytics_storage: "denied" });
    window.gtag("js", new Date());
    window.gtag("config", ADS_ID);
    addScript(`https://www.googletagmanager.com/gtag/js?id=${ADS_ID}`);
  }
  if (PIXEL_ID) {
    /* eslint-disable */
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    PIXEL_IDS.forEach((id) => window.fbq("init", id));
    fbTrack("PageView");
  }
}

export function trackLead() {
  if (!loaded) return;
  if (window.gtag && ADS_ID && ADS_LABEL) window.gtag("event", "conversion", { send_to: `${ADS_ID}/${ADS_LABEL}` });
  if (window.fbq) fbTrack("Lead");
}

export function captureAttribution() {
  const params = new URLSearchParams(window.location.search);
  const found = {};
  ATTR_KEYS.forEach((k) => { if (params.get(k)) found[k] = params.get(k).slice(0, 200); });
  if (Object.keys(found).length) sessionStorage.setItem("md_attr", JSON.stringify({ ...found, landing: window.location.pathname }));
}

export function getAttribution(page) {
  let a = {};
  try { a = JSON.parse(sessionStorage.getItem("md_attr")) || {}; } catch { a = {}; }
  return { ...a, page: page || window.location.pathname };
}
